export const normalizeCurrency = (currency) => {
  const cur = String(currency || '').trim();
  if (!cur) return '';
  return cur.toUpperCase();
};

export const formatMoney = (value, { locale, currency } = {}) => {
  const n = Number(value || 0);
  const safeNumber = Number.isFinite(n) ? n : 0;

  const cur = normalizeCurrency(currency);
  if (!cur) {
    return safeNumber.toLocaleString(locale);
  }

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: cur,
      currencyDisplay: 'symbol',
      maximumFractionDigits: 2,
    }).format(safeNumber);
  } catch (e) {
    return `${safeNumber.toLocaleString(locale)} ${cur}`;
  }
};
